import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { AdminInvite } from '../models/AdminInvite'
import { ADMINS_INVITES_URL } from '../utils/urls'

const fetchAdminInvites = (params: TableParams) =>
  SBAPI.FetchPaginated<AdminInvite[]>(ADMINS_INVITES_URL, params)

const fetchAdminInviteById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<AdminInvite>(`${ADMINS_INVITES_URL}/${id}`, params)

const createAdminInvite = (adminInvite: AdminInvite) =>
  SBAPI.Post(`${ADMINS_INVITES_URL}/${adminInvite.id}/send`, adminInvite)

const updateAdminInvite = (adminInvite: AdminInvite) =>
  SBAPI.Put(`${ADMINS_INVITES_URL}/${adminInvite.id}`, adminInvite)

const deleteAdminInvite = (adminInvite: AdminInvite) =>
  SBAPI.Delete(`${ADMINS_INVITES_URL}/${adminInvite.id}`)

export {
  createAdminInvite,
  deleteAdminInvite,
  fetchAdminInviteById,
  fetchAdminInvites,
  updateAdminInvite,
}
